"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * The CreateSolarSystem model module.
 * @module model/CreateSolarSystem
 * @version 0.1.0
 */
var CreateSolarSystem = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>CreateSolarSystem</code>.
   * @alias module:model/CreateSolarSystem
   * @param siteId {Number} 
   * @param virtualMeterId {Number} 
   * @param name {String} 
   * @param installerId {Number} ID of the contractor who installed the system.
   */
  function CreateSolarSystem(siteId, virtualMeterId, name, installerId) {
    _classCallCheck(this, CreateSolarSystem);
    CreateSolarSystem.initialize(this, siteId, virtualMeterId, name, installerId);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  _createClass(CreateSolarSystem, [{
    key: "getSiteId",
    value:
    /**
         * @return {Number}
         */
    function getSiteId() {
      return this.siteId;
    }

    /**
     * @param {Number} siteId
     */
  }, {
    key: "setSiteId",
    value: function setSiteId(siteId) {
      this['siteId'] = siteId;
    }
    /**
         * @return {Number}
         */
  }, {
    key: "getVirtualMeterId",
    value: function getVirtualMeterId() {
      return this.virtualMeterId;
    }

    /**
     * @param {Number} virtualMeterId
     */
  }, {
    key: "setVirtualMeterId",
    value: function setVirtualMeterId(virtualMeterId) {
      this['virtualMeterId'] = virtualMeterId;
    }
    /**
         * @return {String}
         */
  }, {
    key: "getName",
    value: function getName() {
      return this.name;
    }

    /**
     * @param {String} name
     */
  }, {
    key: "setName",
    value: function setName(name) {
      this['name'] = name;
    }
    /**
         * Returns ID of the contractor who installed the system.
         * @return {Number}
         */
  }, {
    key: "getInstallerId",
    value: function getInstallerId() {
      return this.installerId;
    }

    /**
     * Sets ID of the contractor who installed the system.
     * @param {Number} installerId ID of the contractor who installed the system.
     */
  }, {
    key: "setInstallerId",
    value: function setInstallerId(installerId) {
      this['installerId'] = installerId;
    }
    /**
         * Returns ID of the contractor who is maintaining the system.
         * @return {Number}
         */
  }, {
    key: "getMaintainerId",
    value: function getMaintainerId() {
      return this.maintainerId;
    }

    /**
     * Sets ID of the contractor who is maintaining the system.
     * @param {Number} maintainerId ID of the contractor who is maintaining the system.
     */
  }, {
    key: "setMaintainerId",
    value: function setMaintainerId(maintainerId) {
      this['maintainerId'] = maintainerId;
    }
    /**
         * Returns Date of when the solar system was installed.
         * @return {String}
         */
  }, {
    key: "getInstallationDate",
    value: function getInstallationDate() {
      return this.installationDate;
    }

    /**
     * Sets Date of when the solar system was installed.
     * @param {String} installationDate Date of when the solar system was installed.
     */
  }, {
    key: "setInstallationDate",
    value: function setInstallationDate(installationDate) {
      this['installationDate'] = installationDate;
    }
    /**
         * Returns Date of when the solar system was decommissioned.
         * @return {String}
         */
  }, {
    key: "getDecommissionedDate",
    value: function getDecommissionedDate() {
      return this.decommissionedDate;
    }

    /**
     * Sets Date of when the solar system was decommissioned.
     * @param {String} decommissionedDate Date of when the solar system was decommissioned.
     */
  }, {
    key: "setDecommissionedDate",
    value: function setDecommissionedDate(decommissionedDate) {
      this['decommissionedDate'] = decommissionedDate;
    }
    /**
         * @return {String}
         */
  }, {
    key: "getLocation",
    value: function getLocation() {
      return this.location;
    }

    /**
     * @param {String} location
     */
  }, {
    key: "setLocation",
    value: function setLocation(location) {
      this['location'] = location;
    }
    /**
         * @return {String}
         */
  }, {
    key: "getRoofDirection",
    value: function getRoofDirection() {
      return this.roofDirection;
    }

    /**
     * @param {String} roofDirection
     */
  }, {
    key: "setRoofDirection",
    value: function setRoofDirection(roofDirection) {
      this['roofDirection'] = roofDirection;
    }
    /**
         * @return {String}
         */
  }, {
    key: "getRoofPitch",
    value: function getRoofPitch() {
      return this.roofPitch;
    }

    /**
     * @param {String} roofPitch
     */
  }, {
    key: "setRoofPitch",
    value: function setRoofPitch(roofPitch) {
      this['roofPitch'] = roofPitch;
    }
    /**
         * @return {String}
         */
  }, {
    key: "getPanelPitch",
    value: function getPanelPitch() {
      return this.panelPitch;
    }

    /**
     * @param {String} panelPitch
     */
  }, {
    key: "setPanelPitch",
    value: function setPanelPitch(panelPitch) {
      this['panelPitch'] = panelPitch;
    }
    /**
         * @return {String}
         */
  }, {
    key: "getInverter",
    value: function getInverter() {
      return this.inverter;
    }

    /**
     * @param {String} inverter
     */
  }, {
    key: "setInverter",
    value: function setInverter(inverter) {
      this['inverter'] = inverter;
    }
    /**
         * @return {String}
         */
  }, {
    key: "getInverterUrl",
    value: function getInverterUrl() {
      return this.inverterUrl;
    }

    /**
     * @param {String} inverterUrl
     */
  }, {
    key: "setInverterUrl",
    value: function setInverterUrl(inverterUrl) {
      this['inverterUrl'] = inverterUrl;
    }
    /**
         * @return {String}
         */
  }, {
    key: "getInverterSerialNumber",
    value: function getInverterSerialNumber() {
      return this.inverterSerialNumber;
    }

    /**
     * @param {String} inverterSerialNumber
     */
  }, {
    key: "setInverterSerialNumber",
    value: function setInverterSerialNumber(inverterSerialNumber) {
      this['inverterSerialNumber'] = inverterSerialNumber;
    }
    /**
         * Returns Maximum capacity of the inverter in Watts.
         * @return {String}
         */
  }, {
    key: "getInverterCapacity",
    value: function getInverterCapacity() {
      return this.inverterCapacity;
    }

    /**
     * Sets Maximum capacity of the inverter in Watts.
     * @param {String} inverterCapacity Maximum capacity of the inverter in Watts.
     */
  }, {
    key: "setInverterCapacity",
    value: function setInverterCapacity(inverterCapacity) {
      this['inverterCapacity'] = inverterCapacity;
    }
    /**
         * @return {String}
         */
  }, {
    key: "getPanelType",
    value: function getPanelType() {
      return this.panelType;
    }

    /**
     * @param {String} panelType
     */
  }, {
    key: "setPanelType",
    value: function setPanelType(panelType) {
      this['panelType'] = panelType;
    }
    /**
         * @return {String}
         */
  }, {
    key: "getPanelSize",
    value: function getPanelSize() {
      return this.panelSize;
    }

    /**
     * @param {String} panelSize
     */
  }, {
    key: "setPanelSize",
    value: function setPanelSize(panelSize) {
      this['panelSize'] = panelSize;
    }
    /**
         * @return {Number}
         */
  }, {
    key: "getPanelQuantity",
    value: function getPanelQuantity() {
      return this.panelQuantity;
    }

    /**
     * @param {Number} panelQuantity
     */
  }, {
    key: "setPanelQuantity",
    value: function setPanelQuantity(panelQuantity) {
      this['panelQuantity'] = panelQuantity;
    }
    /**
         * Returns Maximum capacity of the inverter in Watts.
         * @return {Number}
         */
  }, {
    key: "getPanelCapacity",
    value: function getPanelCapacity() {
      return this.panelCapacity;
    }

    /**
     * Sets Maximum capacity of the inverter in Watts.
     * @param {Number} panelCapacity Maximum capacity of the inverter in Watts.
     */
  }, {
    key: "setPanelCapacity",
    value: function setPanelCapacity(panelCapacity) {
      this['panelCapacity'] = panelCapacity;
    }
    /**
         * Returns System peak capacity in Wp.
         * @return {Number}
         */
  }, {
    key: "getPeakCapacity",
    value: function getPeakCapacity() {
      return this.peakCapacity;
    }

    /**
     * Sets System peak capacity in Wp.
     * @param {Number} peakCapacity System peak capacity in Wp.
     */
  }, {
    key: "setPeakCapacity",
    value: function setPeakCapacity(peakCapacity) {
      this['peakCapacity'] = peakCapacity;
    }
    /**
         * Returns Minimum capacity required from the system in Watts.
         * @return {Number}
         */
  }, {
    key: "getMinimumCapacity",
    value: function getMinimumCapacity() {
      return this.minimumCapacity;
    }

    /**
     * Sets Minimum capacity required from the system in Watts.
     * @param {Number} minimumCapacity Minimum capacity required from the system in Watts.
     */
  }, {
    key: "setMinimumCapacity",
    value: function setMinimumCapacity(minimumCapacity) {
      this['minimumCapacity'] = minimumCapacity;
    }
    /**
         * @return {String}
         */
  }, {
    key: "getNotes",
    value: function getNotes() {
      return this.notes;
    }

    /**
     * @param {String} notes
     */
  }, {
    key: "setNotes",
    value: function setNotes(notes) {
      this['notes'] = notes;
    }
    /**
         * @return {Number}
         */
  }, {
    key: "getStatus",
    value: function getStatus() {
      return this.status;
    }

    /**
     * @param {Number} status
     */
  }, {
    key: "setStatus",
    value: function setStatus(status) {
      this['status'] = status;
    }
  }], [{
    key: "initialize",
    value: function initialize(obj, siteId, virtualMeterId, name, installerId) {
      obj['siteId'] = siteId;
      obj['virtualMeterId'] = virtualMeterId;
      obj['name'] = name;
      obj['installerId'] = installerId;
    }

    /**
     * Constructs a <code>CreateSolarSystem</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CreateSolarSystem} obj Optional instance to populate.
     * @return {module:model/CreateSolarSystem} The populated <code>CreateSolarSystem</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new CreateSolarSystem();
        if (data.hasOwnProperty('siteId')) {
          obj['siteId'] = _ApiClient["default"].convertToType(data['siteId'], 'Number');
        }
        if (data.hasOwnProperty('virtualMeterId')) {
          obj['virtualMeterId'] = _ApiClient["default"].convertToType(data['virtualMeterId'], 'Number');
        }
        if (data.hasOwnProperty('name')) {
          obj['name'] = _ApiClient["default"].convertToType(data['name'], 'String');
        }
        if (data.hasOwnProperty('installerId')) {
          obj['installerId'] = _ApiClient["default"].convertToType(data['installerId'], 'Number');
        }
        if (data.hasOwnProperty('maintainerId')) {
          obj['maintainerId'] = _ApiClient["default"].convertToType(data['maintainerId'], 'Number');
        }
        if (data.hasOwnProperty('installationDate')) {
          obj['installationDate'] = _ApiClient["default"].convertToType(data['installationDate'], 'String');
        }
        if (data.hasOwnProperty('decommissionedDate')) {
          obj['decommissionedDate'] = _ApiClient["default"].convertToType(data['decommissionedDate'], 'String');
        }
        if (data.hasOwnProperty('location')) {
          obj['location'] = _ApiClient["default"].convertToType(data['location'], 'String');
        }
        if (data.hasOwnProperty('roofDirection')) {
          obj['roofDirection'] = _ApiClient["default"].convertToType(data['roofDirection'], 'String');
        }
        if (data.hasOwnProperty('roofPitch')) {
          obj['roofPitch'] = _ApiClient["default"].convertToType(data['roofPitch'], 'String');
        }
        if (data.hasOwnProperty('panelPitch')) {
          obj['panelPitch'] = _ApiClient["default"].convertToType(data['panelPitch'], 'String');
        }
        if (data.hasOwnProperty('inverter')) {
          obj['inverter'] = _ApiClient["default"].convertToType(data['inverter'], 'String');
        }
        if (data.hasOwnProperty('inverterUrl')) {
          obj['inverterUrl'] = _ApiClient["default"].convertToType(data['inverterUrl'], 'String');
        }
        if (data.hasOwnProperty('inverterSerialNumber')) {
          obj['inverterSerialNumber'] = _ApiClient["default"].convertToType(data['inverterSerialNumber'], 'String');
        }
        if (data.hasOwnProperty('inverterCapacity')) {
          obj['inverterCapacity'] = _ApiClient["default"].convertToType(data['inverterCapacity'], 'String');
        }
        if (data.hasOwnProperty('panelType')) {
          obj['panelType'] = _ApiClient["default"].convertToType(data['panelType'], 'String');
        }
        if (data.hasOwnProperty('panelSize')) {
          obj['panelSize'] = _ApiClient["default"].convertToType(data['panelSize'], 'String');
        }
        if (data.hasOwnProperty('panelQuantity')) {
          obj['panelQuantity'] = _ApiClient["default"].convertToType(data['panelQuantity'], 'Number');
        }
        if (data.hasOwnProperty('panelCapacity')) {
          obj['panelCapacity'] = _ApiClient["default"].convertToType(data['panelCapacity'], 'Number');
        }
        if (data.hasOwnProperty('peakCapacity')) {
          obj['peakCapacity'] = _ApiClient["default"].convertToType(data['peakCapacity'], 'Number');
        }
        if (data.hasOwnProperty('minimumCapacity')) {
          obj['minimumCapacity'] = _ApiClient["default"].convertToType(data['minimumCapacity'], 'Number');
        }
        if (data.hasOwnProperty('notes')) {
          obj['notes'] = _ApiClient["default"].convertToType(data['notes'], 'String');
        }
        if (data.hasOwnProperty('status')) {
          obj['status'] = _ApiClient["default"].convertToType(data['status'], 'Number');
        }
      }
      return obj;
    }
  }]);
  return CreateSolarSystem;
}();
/**
 * @member {Number} siteId
 */
CreateSolarSystem.prototype['siteId'] = undefined;

/**
 * @member {Number} virtualMeterId
 */
CreateSolarSystem.prototype['virtualMeterId'] = undefined;

/**
 * @member {String} name
 */
CreateSolarSystem.prototype['name'] = undefined;

/**
 * ID of the contractor who installed the system.
 * @member {Number} installerId
 */
CreateSolarSystem.prototype['installerId'] = undefined;

/**
 * ID of the contractor who is maintaining the system.
 * @member {Number} maintainerId
 */
CreateSolarSystem.prototype['maintainerId'] = undefined;

/**
 * Date of when the solar system was installed.
 * @member {String} installationDate
 */
CreateSolarSystem.prototype['installationDate'] = undefined;

/**
 * Date of when the solar system was decommissioned.
 * @member {String} decommissionedDate
 */
CreateSolarSystem.prototype['decommissionedDate'] = undefined;

/**
 * @member {String} location
 */
CreateSolarSystem.prototype['location'] = undefined;

/**
 * @member {String} roofDirection
 */
CreateSolarSystem.prototype['roofDirection'] = undefined;

/**
 * @member {String} roofPitch
 */
CreateSolarSystem.prototype['roofPitch'] = undefined;

/**
 * @member {String} panelPitch
 */
CreateSolarSystem.prototype['panelPitch'] = undefined;

/**
 * @member {String} inverter
 */
CreateSolarSystem.prototype['inverter'] = undefined;

/**
 * @member {String} inverterUrl
 */
CreateSolarSystem.prototype['inverterUrl'] = undefined;

/**
 * @member {String} inverterSerialNumber
 */
CreateSolarSystem.prototype['inverterSerialNumber'] = undefined;

/**
 * Maximum capacity of the inverter in Watts.
 * @member {String} inverterCapacity
 */
CreateSolarSystem.prototype['inverterCapacity'] = undefined;

/**
 * @member {String} panelType
 */
CreateSolarSystem.prototype['panelType'] = undefined;

/**
 * @member {String} panelSize
 */
CreateSolarSystem.prototype['panelSize'] = undefined;

/**
 * @member {Number} panelQuantity
 */
CreateSolarSystem.prototype['panelQuantity'] = undefined;

/**
 * Maximum capacity of the inverter in Watts.
 * @member {Number} panelCapacity
 */
CreateSolarSystem.prototype['panelCapacity'] = undefined;

/**
 * System peak capacity in Wp.
 * @member {Number} peakCapacity
 */
CreateSolarSystem.prototype['peakCapacity'] = undefined;

/**
 * Minimum capacity required from the system in Watts.
 * @member {Number} minimumCapacity
 */
CreateSolarSystem.prototype['minimumCapacity'] = undefined;

/**
 * @member {String} notes
 */
CreateSolarSystem.prototype['notes'] = undefined;

/**
 * @member {Number} status
 */
CreateSolarSystem.prototype['status'] = undefined;
var _default = CreateSolarSystem;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@solarschools/api-sdk/dist/model/CreateSolarSystem.js
// module id = yfIq
// module chunks = 3